module.exports = __webpack_public_path__ + "static/media/assistance_pending.56c1789e.svg";